export default __webpack_public_path__ + "static/media/image.imi-games-pvt-ltd.c59996b6.png";